import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { CustomTimePicker } from './CustomTimePicker';
import { selectEventDialogDataEndTimeDate } from 'main/store/schedule/selectors';
import { actions } from 'main/store/schedule/reducer';

export const EndTimePicker = () => {
    const dispatch = useDispatch();
    const value = useSelector(selectEventDialogDataEndTimeDate);

    const handleChange = useCallback((time: string) => {
        dispatch(actions.changeEventDialogDataEndTime(time));
    }, [dispatch]);

    return (
        <CustomTimePicker label="終了時刻" value={value} onChange={handleChange} />
    )
}
